module.exports = __webpack_public_path__ + "static/media/temp_29.9362320d.jpg";